import { getBase64 } from '@repo/lib/fs/getBase64';
import { useEffect, useRef, useState } from 'react';

import type { ProgressiveImageLoaderProps } from '.';

export function useProgressiveImageLoader(progressiveImageLoaderProps: ProgressiveImageLoaderProps) {
  const { thumbnail, type, onLoad, onError } = progressiveImageLoaderProps;
  const pictureRef = useRef<HTMLPictureElement>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const base64 = getBase64({
    base64: thumbnail,
    fileType: type,
    clear: true,
  });

  useEffect(() => {
    const picture = pictureRef.current;
    if (picture) {
      const sourceElements = picture.getElementsByTagName('source');
      for (let i = 0; i < sourceElements.length; i++) {
        const source = sourceElements[i];
        const dataSrcset = source?.getAttribute('data-srcset');
        if (!dataSrcset || !source) return;
        source.setAttribute('srcset', dataSrcset);
      }

      const img = picture.getElementsByTagName('img')[0];
      const dataSrc = img?.getAttribute('data-src');
      if (!img || !dataSrc) return;
      const highResImage = new window.Image();
      highResImage.src = dataSrc;

      highResImage.onload = () => {
        img.src = dataSrc;
        onLoad?.();
        setTimeout(() => {
          setIsLoaded(true);
        }, 80);
      };

      highResImage.onerror = () => {
        setIsError(true);
        onError?.();
      };
    }
  }, [onLoad, onError]);

  return {
    pictureRef,
    isLoaded,
    isError,
    base64,
  };
}
